import { makeAutoObservable } from 'mobx';
import { Product } from 'screens/Paywall/types';
import { stores } from 'state/stores';
import { log } from 'utils/log';

export class UnauthenticatedPaywallViewModel {
  constructor() {
    makeAutoObservable(this);

    log('👷‍♂️ init UnauthenticatedPaywallViewModel');

    this.fetchProductData();
  }

  fetchProductData = async () => {
    await stores.paddlePrices.fetch();
  };

  openedFaqIndex?: number;

  onFAQPress = (index: number) => {
    if (index === this.openedFaqIndex) {
      this.openedFaqIndex = undefined;
    } else {
      this.openedFaqIndex = index;
    }
  };

  selectedProductId: string = 'hevypro_yearly_tier24';

  get selectedProductPrice() {
    return stores.paddlePrices.prices.find(p => p.paddle_price_id === this.selectedProductId)
      ?.price_usd;
  }

  get ctaTitle() {
    return 'Get Started';
  }

  onCtaClick = async () => {
    window.location.href = '/signup';
  };

  get products(): Product[] {
    const { selectedProductId } = this;

    const { monthlyPrice, yearlyPrice, lifetimePrice } = stores.paddlePrices;
    if (!monthlyPrice || !yearlyPrice || !lifetimePrice) return [];
    return [
      {
        key: 'hevypro_1month_tier3',
        title: 'Monthly',
        description: 'Billed monthly',
        price: `$${monthlyPrice.price_usd}`,
        isSelected: selectedProductId === 'hevypro_1month_tier3',
        onClick: () => (this.selectedProductId = 'hevypro_1month_tier3'),
      },
      {
        key: 'hevypro_yearly_tier24',
        title: 'Yearly',
        description: 'Billed yearly',
        discountedPrice: undefined,
        price: `$${yearlyPrice.price_usd}`,
        hint: undefined,
        isSelected: selectedProductId === 'hevypro_yearly_tier24',
        onClick: () => (this.selectedProductId = 'hevypro_yearly_tier24'),
      },
      {
        key: 'hevypro_lifetime_tier55',
        title: 'Lifetime',
        description: 'Pay once',
        price: `$${lifetimePrice.price_usd}`,
        isSelected: selectedProductId === 'hevypro_lifetime_tier55',
        onClick: () => (this.selectedProductId = 'hevypro_lifetime_tier55'),
      },
    ];
  }
}
